import { useFetch, useIsLoading } from "../../../Hooks/useFetch";
import EntitySection from "../../Shared/EntitySection/EntitySection";
import { idColumn, nameColumn, partnerTypeColumn, partnerTypeLabel, textColumn } from "../../Shared/TableColumns/tableColumns";
import { selectFilter } from "../../Shared/TableFilters/filterDefs";
import { deleteParther, getAllParther } from "../../../Service/PartherService/PartherService";
import PartnerDetail from "./PartnerDetail";
import { invalidateCatalog } from "../../../Hooks/useCatalogs";

function Partner() {
  const [partners, isFetchingPartners, updatePartners] = useFetch(getAllParther);
  const isLoading = useIsLoading([isFetchingPartners]);

  const columns = [
    idColumn(),
    nameColumn("name", "Razón social"),
    textColumn("cif", "CIF"),
    partnerTypeColumn(),
    textColumn("email", "Email"),
    textColumn("telephone", "Teléfono"),
  ];

  const filters = [
    selectFilter(
      "partnerType",
      "Tipo",
      ["Partner", "Fabricante", "Partner y fabricante"].map((label) => ({ value: label, label })),
      partnerTypeLabel
    ),
  ];

  return (
    <EntitySection
      filters={filters}
      title="Partner o fabricante"
      addLabel="Añadir partner"
      type="partner"
      rows={partners}
      loading={isLoading}
      columns={columns}
      onDelete={(row) => deleteParther(row).then(() => invalidateCatalog("partner"))}
      onChanged={updatePartners}
      detailTitle="Información del Partner / Fabricante"
      renderDetail={(row) => <PartnerDetail row={row} />}
    />
  );
}

export default Partner;
